// extracted by mini-css-extract-plugin
module.exports = {"container":"If-z","creativeContainer":"Jf-z","copy":"Kf-z","cta":"Lf-z","disabled":"Mf-z","flipped":"Nf-z","card":"Of-z"};